var _circle, _circle2, _circle3, _ellipse, _ellipse2, _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgProfile11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#FBD5D5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1048,
    cy: 12.2676,
    r: 3.35353,
    fill: "#333B4F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.1048,
    cy: 28.124,
    r: 14.9619,
    fill: "#FFF3F1"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.9774,
    cy: 31.2192,
    rx: 1.03186,
    ry: 1.54778,
    fill: "#262626"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.2322,
    cy: 31.2192,
    rx: 1.03186,
    ry: 1.54778,
    fill: "#262626"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1685 34.8306H23.7831C23.7831 35.8624 24.557 36.6363 26.1048 36.6363C27.564 36.6363 28.0825 35.5185 28.1685 34.8306Z",
    fill: "#F09387"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.161 28.8678L21.7349 22.7768C24.7274 24.8549 32.0102 27.0452 41.0353 29.1015C41.0561 28.7784 41.0667 28.4524 41.0667 28.124C41.0667 19.8608 34.368 13.1621 26.1048 13.1621C17.8416 13.1621 11.1429 19.8608 11.1429 28.124C11.1429 28.3734 11.149 28.6214 11.161 28.8678Z",
    fill: "#333B4F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.3512,
    y: 12.7451,
    width: 0.845878,
    height: 6.49126,
    transform: "rotate(90.1045 29.3512 12.7451)",
    fill: "#FF8282"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfile11);
export default __webpack_public_path__ + "static/media/img_profile_11.0df24fa18989d53f8e38114b66f65c7b.svg";
export { ForwardRef as ReactComponent };